import { createContext, useContext } from 'react';
import FormState from 'core/form/FormState';

const FormContext = createContext<FormState | null>(null);
export default FormContext;
export const useFormContext = () => useContext(FormContext);
